import React from 'react'

const Social = () => {
    return (
        <div className="home__social">
            <a href="https://www.instagram.com/mr._kamlesh_pawar_" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-instagram"></i>
            </a>

            <a href="https://api.whatsapp.com/send?phone=+919172121327&text=Hello, more information!" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-whatsapp"></i>
            </a>

            <a href="https://github.com/mr-kamlesh-pawar" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-github-alt"></i>
            </a>
        </div>
    )
}

export default Social